import { useRef } from 'react';

/**
 * Memoize a value based on an isEqual predicate instead of reference equality.
 * @param value Value to memoize
 * @param isEqual Predicate to see if value has changed since last render
 */
export function useIsEqualMemo(value, isEqual) {
  var previousValueRef = useRef(value);
  var currentValue = isEqual(previousValueRef.current, value) ? previousValueRef.current : value;
  previousValueRef.current = currentValue;
  return currentValue;
}
export default useIsEqualMemo;
//# sourceMappingURL=useIsEqualMemo.js.map